export const SubscriptionPlans = {
  SaveBtn: 'save-btn',
} as const;
